import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { customerService } from '../services/customerService'

export const getAllCustomers = createAsyncThunk(
  'customer/getAll',
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = await customerService.getAll(params)
      return response.data
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  },
)

export const getOneCustomer = createAsyncThunk(
  'customer/getOne',
  async (data, { rejectWithValue }) => {
    try {
      const response = await customerService.getOne(data)
      return response.data
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  },
)

const initialState = {
  data: { data: [], current_page: 1, per_page: 10, total: 0, last_page: 1 },
  singleData: {},
  loading: false,
  error: false,
  message: '',
}

const slice = createSlice({
  name: 'patient',
  initialState,
  reducers: {
    checkAll: (state) => {
      state.isChecked = !state.isChecked
    },
    resetSingleData: (state) => {
      state.singleData = {}
    },
  },
  extraReducers: {
    [getAllCustomers.pending]: (state) => {
      if (!state.data?.data?.length) {
        state.loading = true
      }
    },
    [getAllCustomers.fulfilled]: (state, action) => {
      state.error = false
      state.data = action.payload
      state.loading = false
    },
    [getAllCustomers.rejected]: (state, action) => {
      state.error = true
      state.message = action.payload
      state.loading = false
    },

    [getOneCustomer.pending]: (state) => {
      state.loading = true
    },
    [getOneCustomer.fulfilled]: (state, { payload }) => {
      state.message = payload?.message
      state.loading = false
      state.singleData = payload
    },
    [getOneCustomer.rejected]: (state, { payload }) => {
      state.error = true
      state.message = payload
      state.loading = false
    },
  },
})

export const { resetSingleData } = slice.actions
export default slice.reducer
